import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ConfigurationProtocolCreateRequest,
    ConfigurationProtocolPatchInBatchRequest,
    ConfigurationProtocolResponse
} from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationProtocolService {
    async create(laboratoryId: number, request: ConfigurationProtocolCreateRequest): Promise<ConfigurationProtocolResponse> {
        const response = await axios.post<ConfigurationProtocolResponse>(`/configuration/laboratories/${laboratoryId}/protocols`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationProtocolResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationProtocolResponse>>(`/configuration/laboratories/${laboratoryId}/protocols`, { ...filterModel }, { params })
        return response.data
    }

    async get(protocolId: number, laboratoryId: number): Promise<ConfigurationProtocolResponse> {
        const response = await axios.get<ConfigurationProtocolResponse>(`/configuration/laboratories/${laboratoryId}/protocols/${protocolId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/protocols/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationProtocolPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/protocols/batch`, request)
        return response.data
    }
}

export const configurationProtocolService = new ConfigurationProtocolService()
